import React from "react";
import { Typography } from "@material-ui/core";
import { ArrowBackIos, ArrowForwardIos } from "@material-ui/icons";
import { getStoredLanguage } from "~/i18n";
import { useSelector } from "react-redux";

const DateNavigator = ({ date, availableDatesCalendar, onDateChange }) => {
	const { business } = useSelector((store) => store.business);
	const currentDateString = new Date(date).toISOString().split('T')[0];

	const getPastDates = () => {
		return (availableDatesCalendar || []).filter(dateString => dateString < currentDateString);
	};

	const getFutureDates = () => {
		return (availableDatesCalendar || []).filter(dateString => dateString > currentDateString);
	};

	const handlePreviousDate = () => {
		const pastDates = getPastDates();
		if (pastDates.length > 0) {
			const previousDateString = pastDates[pastDates.length - 1];
			const previousDate = new Date(previousDateString + 'T00:00:00');
			onDateChange(previousDate);
		}
	};

	const handleNextDate = () => {
		const futureDates = getFutureDates();
		if (futureDates.length > 0) {
			const nextDateString = futureDates[0];
			const nextDate = new Date(nextDateString + 'T00:00:00');
			onDateChange(nextDate);
		}
	};

	const formatDate = () => {
		const dateStr = new Date(date).toLocaleDateString(getStoredLanguage(business?.language) || 'pt-BR', { 
			day: "2-digit", 
			month: "short" 
		});
		const formatted = dateStr.replace(' de ', '/').replace('.', '');
		const parts = formatted.split('/');
		if (parts.length === 2) {
			const month = parts[1].charAt(0).toUpperCase() + parts[1].slice(1).toLowerCase();
			return `${parts[0]}/${month}`;
		}
		return formatted;
	};

	const pastDates = getPastDates();
	const futureDates = getFutureDates();

	return (
		<div style={{ display: "flex", alignItems: "center", gap: 10, justifyContent: "center" }}>
			{/* Seta para voltar (esquerda) */}
			{pastDates.length > 0 && (
				<div 
					style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
					onClick={handlePreviousDate}
				>
					<ArrowBackIos style={{ fontSize: 18, color: "#333" }}/>
				</div>
			)}
			
			{/* Data */}
			<div>
				<Typography style={{ fontSize: 24, color: "#333", fontWeight: 500, lineHeight: 1.2 }}>
					{formatDate()}
				</Typography>
			</div>

			{/* Seta para avançar (direita) */}
			{futureDates.length > 0 && (
				<div 
					style={{ cursor: "pointer", display: "flex", alignItems: "center" }}
					onClick={handleNextDate}
				>
					<ArrowForwardIos style={{ fontSize: 18, color: "#333" }}/>
				</div>
			)}
		</div>
	);
};

export default DateNavigator;
